import { FixaListBox } from "@coworker/apprestructured/src/shared/wrappers/FixaListBox/FixaListBox";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";
import FixaPill from "@coworker/apprestructured/src/shared/wrappers/FixaPill/FixaPill";
import FixaChevronDownIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/ChevronDownIconPath";
import FixaChevronUpIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/ChevronUpIconPath";
import { useTranslation } from "@coworker/locales";
import { useState } from "react";
import { locations, mediaTypes } from "../../pages/mock-media";
import styles from "./launch-media-filters.module.css";

const FISCAL_YEARS = ["FY26", "FY27"];

const FiscalYearPill = ({ label }: { label: string }) => {
  const [selected, setSelected] = useState(false);

  return (
    <FixaPill
      label={label}
      size="small"
      selected={selected}
      onClick={() => setSelected((current) => !current)}
    />
  );
};

const DropdownFilterPill = ({
  label,
  options = [],
}: {
  label: string;
  options?: string[];
}) => {
  const [open, setOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState<string | undefined>();

  return (
    <div className={styles["dropdown"]}>
      <FixaPill
        label={label}
        size="small"
        selected={open}
        trailingIcon={open ? FixaChevronUpIconPath : FixaChevronDownIconPath}
        onClick={() => setOpen((current) => !current)}
      />

      {open && (
        <div className={styles["backdrop"]} onClick={() => setOpen(false)} />
      )}

      <FixaListBox
        className={styles["dropdown-list"]}
        open={open}
        position="left"
      >
        {options.length > 0 && (
          <FixaListView
            id={`listview-${label}`}
            size="small"
            showDivider={false}
          >
            {options.map((option) => {
              const isSelected = selectedOption === option;

              return (
                <FixaListViewItem
                  key={option}
                  inset
                  control="radiobutton"
                  controlProps={{
                    value: isSelected ? "ON" : "OFF",
                    checked: isSelected,
                  }}
                  showDivider={false}
                  title={option}
                  onChange={() => setSelectedOption(option)}
                />
              );
            })}
          </FixaListView>
        )}
      </FixaListBox>
    </div>
  );
};

export const LaunchMediaFilters = () => {
  const { t } = useTranslation();

  // Options are added once the underlying media data supports filtering.
  const dropdownFilters: { label: string; options?: string[] }[] = [
    { label: t("allMediaTypesString"), options: mediaTypes },
    { label: t("locationFilterLabelString"), options: locations },
    {
      label: t("launchLabelString"),
      options: ["Launch 1", "Launch 2", "Launch 3", "Launch 4"],
    },
  ];

  return (
    <div className={styles["filters"]} aria-label="Filters">
      {FISCAL_YEARS.map((year) => (
        <FiscalYearPill key={year} label={year} />
      ))}
      {dropdownFilters.map(({ label, options }) => (
        <DropdownFilterPill key={label} label={label} options={options} />
      ))}
    </div>
  );
};
